// import TdmOcaPhoto from '../images/ProductImg/TdmOca.jpg';
// import TdmOcrPhoto from '../images/ProductImg/TdmOcr.jpg';
// import TdmTOcaPhoto from '../images/ProductImg/TdmTOca.jpg';

// export const TdmTopImg = [
//   {
//     id: 1,
//     image: require('../images/ProductImg/TdmTop/TdmProductA.jpg'),
//     alt: 'images/ProductImg/TdmTop/TdmProductA.png',
//     link: '',
//   },
//   {
//     id: 2,
//     image: require('../images/ProductImg/TdmTop/TdmProductB.jpg'),
//     alt: 'images/ProductImg/TdmTop/TdmProductB.png',
//     link: '',
//   },
//   {
//     id: 3,
//     image: require('../images/ProductImg/TdmTop/TdmProductC.jpg'),
//     alt: 'images/ProductImg/TdmTop/TdmProductB.png',
//     link: '',
//   },
//   {
//     id: 4,
//     image: require('../images/ProductImg/TdmTop/TdmProductD.jpg'),
//     alt: 'images/ProductImg/TdmTop/TdmProductD.png',
//     link: '',
//   },
//   {
//     id: 5,
//     image: require('../images/ProductImg/TdmTop/TouchLcm185.jpg'),
//     alt: 'images/ProductImg/TdmTop/TouchLcm185.png',
//     link: '',
//   },
//   {
//     id: 6,
//     image: require('../images/ProductImg/TdmTop/TouchLcm215.jpg'),
//     alt: 'images/ProductImg/TdmTop/TouchLcm215.png',
//     // link: 'https://xxxxxx.com/ProductTdm/xxxxxx',
//   },
// ]

export const TdmOcaImg = [
  {
    id: 1,
    image: require('../images/ProductImg/TdmOca/TdmOcaProductA.jpg'),
    alt: 'images/ProductImg/TdmOca/TdmOcaroductA.png',
  },
  {
    id: 2,
    image: require('../images/ProductImg/TdmOca/TdmOcaProductB.jpg'),
    alt: 'images/ProductImg/TdmOca/TdmOcaroductB.png',
  },
  {
    id: 3,
    image: require('../images/ProductImg/TdmOca/TdmOcaProductC.jpg'),
    alt: 'images/ProductImg/TdmOca/TdmOcaroductC.png',
  },
  {
    id: 4,
    image: require('../images/ProductImg/TdmOca/TouchLcm156.jpg'),
    alt: 'images/ProductImg/TdmOca/TouchLcm156.png',
  },
  {
    id: 5,
    image: require('../images/ProductImg/TdmOca/TouchLcm185.jpg'),
    alt: 'images/ProductImg/TdmOca/TouchLcm185.png',
  },
  {
    id: 6,
    image: require('../images/ProductImg/TdmOca/OcaDBond.jpg'),
    alt: 'images/ProductImg/TdmOca/OcaDBond.png',
  },
  // {
  //   id: 7,
  //   image: require('../images/ProductImg/TdmOca/-7.jpg'),
  //   alt: 'images/ProductImg/TdmOca/-7.png',
  // },
  // {
  //   id: 8,
  //   image: require('../images/ProductImg/TdmOca/-8.jpg'),
  //   alt: 'images/ProductImg/TdmOca/-8.png',
  // },
  // {
  //   id: 9,
  //   image: require('../images/ProductImg/TdmOca/-9.jpg'),
  //   alt: 'images/ProductImg/TdmOca/-9.png',
  // },
  // {
  //   id: 10,
  //   image: require('../images/ProductImg/TdmOca/-12.jpg'),
  //   alt: 'images/ProductImg/TdmOca/-12.png',
  //   // link: 'https://xxxxxx.com/design/xxxxxx',
  // },
]

export const TdmOcaTxt = [
  {
    id: 1,
    image: require('../images/ProductImg/TdmOca/OcaDBond.jpg'),
    // image: TdmOcaDBondImg,
    alt: 'images/ProductImg/TdmOca/OcaDBond.jpg',
    name: 'OCA Optical Bonding 1',
    title: 'OCA Optical Bonding 1',
    text: 'OCA TP+LCM=>TDM全貼合一',
    text_eng: 'OCA Optical Bonding/Direct Bonding 1',
    text_cht: 'OCA TP+LCM=>TDM全貼合一',
    text_chs: 'OCA TP+LCM=>TDM全貼合一',
    describe: 'OCA Optical Bonding/Direct Bonding 1',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 2,
    image: require('../images/ProductImg/TdmOca/OcaDBond.jpg'),
    // image: TdmOcaDBondImg,
    alt: 'images/ProductImg/TdmOca/OcaDBond.jpg',
    name: 'OCA Optical Bonding 2',
    title: 'OCA Optical Bonding 2',
    text: 'OCA TP+LCM=>TDM全貼合二',
    text_eng: 'OCA Optical Bonding/Direct Bonding 2',
    text_cht: 'OCA TP+LCM=>TDM全貼合二',
    text_chs: 'OCA TP+LCM=>TDM全貼合二',
    describe: 'OCA Optical Bonding/Direct Bonding 2',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 3,
    image: require('../images/ProductImg/TdmOca/OcaDBond.jpg'),
    // image: TdmOcaDBondImg,
    alt: 'images/ProductImg/TdmOca/OcaDBond.jpg',
    name: 'OCA Optical Bonding 3',
    title: 'OCA Optical Bonding 3',
    text: 'OCA TP+LCM=>TDM全貼合三',
    text_eng: 'OCA Optical Bonding/Direct Bonding 3',
    text_cht: 'OCA TP+LCM=>TDM全貼合三',
    text_chs: 'OCA TP+LCM=>TDM全貼合三',
    describe: 'OCA Optical Bonding/Direct Bonding 3',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
]

export const TdmOcrImg = [
  {
    id: 1,
    image: require('../images/ProductImg/TdmOcr/OcrDBond.jpg'),
    alt: 'images/ProductImg/TdmOcr/OcrDBond.jpg',
  },
  {
    id: 2,
    image: require('../images/ProductImg/TdmOcr/TouchLcm185.jpg'),
    alt: 'images/ProductImg/TdmOcr/TouchLcm185.jpg',
  },
  {
    id: 3,
    image: require('../images/ProductImg/TdmOcr/TouchLcm215.jpg'),
    alt: 'images/ProductImg/TdmOcr/TouchLcm215.jpg',
  },
  {
    id: 4,
    image: require('../images/ProductImg/TdmOcr/TdmOcrProductA.jpg'),
    alt: 'images/ProductImg/TdmOcr/TdmOcrProductA.jpg',
  },
  {
    id: 5,
    image: require('../images/ProductImg/TdmOcr/TdmOcrProductB.jpg'),
    alt: 'images/ProductImg/TdmOcr/TdmOcrProductB.jpg',
  },
  // {
  //   id: 6,
  //   image: require('../images/ProductImg/TdmOcr/-6.jpg'),
  //   alt: 'images/ProductImg/TdmOcr/Ocr-6.png',
  // },
  // {
  //   id: 7,
  //   image: require('../images/ProductImg/TdmOcr/-7.jpg'),
  //   alt: 'images/ProductImg/TdmOcr/Ocr-7.png',
  // },
  // {
  //   id: 8,
  //   image: require('../images/ProductImg/TdmOcr/-8.jpg'),
  //   alt: 'images/ProductImg/TdmOcr/Ocr-8.png',
  // },
  // {
  //   id: 9,
  //   image: require('../images/ProductImg/TdmOcr/-9.jpg'),
  //   alt: 'images/ProductImg/TdmOcr/Ocr-9.png',
  // },
  // {
  //   id: 10,
  //   image: require('../images/ProductImg/TdmOcr/-10.jpg'),
  //   alt: 'images/ProductImg/TdmOcr/Ocr-10.png',
  // },
  // {
  //   id: 11,
  //   image: require('../images/ProductImg/TdmOcr/-11.jpg'),
  //   alt: 'images/ProductImg/TdmOcr/Ocr-11.png',
  //   link: '',
  // },
  // {
  //   id: 12,
  //   image: require('../images/ProductImg/TdmOcr/-12.jpg'),
  //   alt: 'images/ProductImg/TdmOcr/Ocr-12.png',
  //   // link: 'https://xxxxxx.com/design/xxxxxx',
  // },
]

export const TdmOcrTxt = [
  {
    id: 1,
    image: require('../images/ProductImg/TdmOcr/OcrDBond.jpg'),
    // image: TdmOcrDbondImg,
    alt: 'images/ProductImg/OcrDBond.jpg',
    name: 'OCR Optical Bonding 1',
    title: 'OCR Optical Bonding 1',
    text: 'OCR TP+LCM=>TDM全貼合一',
    text_eng: 'OCR Optical Bonding/Direct Bonding 1',
    text_cht: 'OCR TP+LCM=>TDM全貼合一',
    text_chs: 'OCR TP+LCM=>TDM全貼合一',
    describe: 'OCR Optical Bonding/Direct Bonding 1',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 2,
    image: require('../images/ProductImg/TdmOcr/OcrDBond.jpg'),
    // image: TdmOcrDbondImg,
    alt: 'images/ProductImg/OcrDBond.jpg',
    name: 'OCR Optical Bonding 2',
    title: 'OCR Optical Bonding 2',
    text: 'OCR TP+LCM=>TDM全貼合二',
    text_eng: 'OCR Optical Bonding/Direct Bonding 2',
    text_cht: 'OCR TP+LCM=>TDM全貼合二',
    text_chs: 'OCR TP+LCM=>TDM全貼合二',
    describe: 'OCR Optical Bonding/Direct Bonding 2',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 3,
    image: require('../images/ProductImg/TdmOcr/OcrDBond.jpg'),
    // image: TdmOcrDbondImg,
    alt: 'images/ProductImg/OcrDBond.jpg',
    name: 'OCR Optical Bonding 3',
    title: 'OCR Optical Bonding 3',
    text: 'OCR TP+LCM=>TDM全貼合三',
    text_eng: 'OCR Optical Bonding/Direct Bonding 3',
    text_cht: 'OCR TP+LCM=>TDM全貼合三',
    text_chs: 'OCR TP+LCM=>TDM全貼合三',
    describe: 'OCR Optical Bonding/Direct Bonding 3',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
]

export const TdmTOcaImg = [
  {
    id: 1,
    image: require('../images/ProductImg/TdmTOca/TdmTOcaProductA.jpg'),
    alt: 'images/ProductImg/TdmTOca/TdmTOcaProductA.jpg',
  },
  {
    id: 2,
    image: require('../images/ProductImg/TdmTOca/TdmTOcaProductB.jpg'),
    alt: 'images/ProductImg/TdmTOca/TdmTOcaProductB.png',
  },
  {
    id: 3,
    image: require('../images/ProductImg/TdmTOca/TdmTOcaProductC.jpg'),
    alt: 'images/ProductImg/TdmTOca/TdmTOcaProductC.png',
  },
  {
    id: 5,
    image: require('../images/ProductImg/TdmTOca/TOcaDBond.jpg'),
    alt: 'images/ProductImg/TdmTOca/TOcaDBond.jpg',
  },
  // {
  //   id: 6,
  //   image: require('../images/ProductImg/TdmTOca/-6.jpg'),
  //   alt: 'images/ProductImg/TdmTOca/-6.png',
  // },
  // {
  //   id: 7,
  //   image: require('../images/ProductImg/TdmTOca/-7.jpg'),
  //   alt: 'images/ProductImg/TdmTOca/-7.png',
  // },
  // {
  //   id: 8,
  //   image: require('../images/ProductImg/TdmTOca/-8.jpg'),
  //   alt: 'images/ProductImg/TdmTOca/-8.png',
  // },
  // {
  //   id: 9,
  //   image: require('../images/ProductImg/TdmTOca/-9.jpg'),
  //   alt: 'images/ProductImg/TdmTOca/-9.png',
  //   // link: 'https://xxxxxx.com/design/xxxxxx',
  // },
]

export const TdmTOcaTxt = [
  {
    id: 1,
    image: require('../images/ProductImg/TdmTOca/TOcaDBond.jpg'),
    // image: TdmTocaDBondImg,
    alt: 'images/ProductImg/TdmTocaDBond.jpg',
    name: 'TOCA Optical Bonding 1',
    title: 'TOCA Optical Bonding 1',
    text: 'TOCA TP+LCM=>TDM全貼合一',
    text_eng: 'TOCA Optical Bonding/Direct Bonding 1',
    text_cht: 'TOCA TP+LCM=>TDM全貼合一',
    text_chs: 'TOCA TP+LCM=>TDM全貼合一',
    describe: 'TOCA Optical Bonding/Direct Bonding 1',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 2,
    image: require('../images/ProductImg/TdmTOca/TOcaDBond.jpg'),
    // image: TdmTocaDBondImg,
    alt: 'images/ProductImg/TdmTocaDBond.jpg',
    name: 'TOCA Optical Bonding 2',
    title: 'TOCA Optical Bonding 2',
    text: 'TOCA TP+LCM=>TDM全貼合二',
    text_eng: 'TOCA Optical Bonding/Direct Bonding 2',
    text_cht: 'TOCA TP+LCM=>TDM全貼合二',
    text_chs: 'TOCA TP+LCM=>TDM全貼合二',
    describe: 'TOCA Optical Bonding/Direct Bonding 2',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
  {
    id: 3,
    image: require('../images/ProductImg/TdmTOca/TOcaDBond.jpg'),
    // image: TdmTocaDBondImg,
    alt: 'images/ProductImg/TdmTocaDBond.jpg',
    name: 'TOCA Optical Bonding 3',
    title: 'TOCA Optical Bonding 3',
    text: 'TOCA TP+LCM=>TDM全貼合三',
    text_eng: 'TOCA Optical Bonding/Direct Bonding 3',
    text_cht: 'TOCA TP+LCM=>TDM全貼合三',
    text_chs: 'TOCA TP+LCM=>TDM全貼合三',
    describe: 'TOCA Optical Bonding/Direct Bonding 3',
    link: 'https://www.hlzoptics.com',
    time: '2025/2/1',
  },
]
